<template>
  <div class="section section--spacing-short section--background-tertiary">

    <div v-if="rawTitle"
         class="wrapper">
      <div class="container">
        <div class="small-width">
          <macro-title
            :title="rawTitle"
            add-class="m-slider__title h2 font-weight-bold text-align-center"
          />
        </div>
      </div>
    </div>

    <div class="slider__wrapper">
      <swiper ref="mySwiper"
              v-if="itemsSlider"
              :auto-update="true"
              :options="swiperOptions">
        <swiper-slide v-for="(item, key) in itemsSlider"
                      class="slider__item"
                      :class="[{'slider__item--has-link': item.link}]"
                      :key="'slide-' + key">
          <figure class="figure figure--slider" v-if="item.image">
            <picture>
<!--              <img :data-src="isWebpEnable ? item.image.data.slider[0].replace('.jpg', '.webp') : item.image.data.slider[0]"
                   class="swiper-lazy"
                   width="638"
                   height="480"
                   :alt="item.image.data.alt" />-->
              <img :data-src="item.image.data.slider[0]"
                   class="swiper-lazy"
                   width="638"
                   height="480"
                   :alt="item.image.data.alt" />
            </picture>
          </figure>

          <template v-if="item.link">
            <a class="slider__item-content"
               :href="item.link.url"
               :target="item.link.target === '_blank' ? '_blank' : '_self'">
              <macro-title :title="item.suptitle" add-class="title--small"></macro-title>
              <macro-title :title="item.title" add-class="h3 slider__item-title font-weight-bold"></macro-title>
              <span class="action action--bordered action--bordered-white">
                <span class="action__text">{{item.link.title}}</span>
              </span>

            </a>
          </template>
          <template v-else>
            <div class="slider__item-content">
              <macro-title :title="item.suptitle" add-class="title--small"></macro-title>
              <macro-title :title="item.title" add-class="h3 font-weight-bold"></macro-title>
            </div>
          </template>


          <div class="swiper-lazy-preloader swiper-lazy-preloader-black"></div>
        </swiper-slide>

      </swiper>

      <div class="slider-navigation">
        <button class="swiper-button-prev slider__button slider__button--prev">
          <span class="visually-hidden">←</span>
          <v-icon-arrow-left :theme="theme"></v-icon-arrow-left>
        </button>
        <button class="swiper-button-next slider__button slider__button--next">
          <span class="visually-hidden">→</span>
          <v-icon-arrow-right :theme="theme"></v-icon-arrow-right>
        </button>
      </div>
    </div>

    <div v-if="cleanLink.url"
         class="action__container action__container--center m-slider__action">
      <a :href="cleanLink.url"
         class="action action--bordered"
         :target="cleanLink.target === '_blank' ? '_blank' : '_self'">
        <span class="action__text">{{ cleanLink.title }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VIconArrowLeft from '../VIcons/VIconArrowLeft.vue';
import VIconArrowRight from '../VIcons/VIconArrowRight.vue';
import SwiperCore, {Navigation, Keyboard, Lazy } from 'swiper';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import {getImage} from '../rest-service/rest-service';
import AsyncComputed from 'vue-async-computed';
import MacroTitle from '../MacroTitle/MacroTitle.vue';
import {isWebP} from '../utils/isWebP';
Vue.use(AsyncComputed);

// install Swiper components
SwiperCore.use([Navigation, Keyboard, Lazy]);
export default {
  name: "VSlider",
  components: {
    Swiper,
    SwiperSlide,
    MacroTitle,
    VIconArrowLeft,
    VIconArrowRight
  },
  data () {
    return {
      isWebpEnable: true,
      isDataReady: false,
      swiperOptions: {
        slidesPerView: 'auto',
        // Disable preloading of all images
        preloadImages: false,
        watchSlidesVisibility: true,
        // Enable lazy loading
        lazy: {
          loadOnTransitionStart: true,
          loadPrevNext: true,
          loadPrevNextAmount: 2,
          checkInView: true,
        },
        spaceBetween: 27,
        loop: true,
        autoHeight: true, //enable auto height

        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          320: {
            centeredSlides: false,
            spaceBetween: 10,
          },
          768: {
            centeredSlides: false,
            spaceBetween: 30,

          },
          1180: {
            centeredSlides: true,
            spaceBetween: 60
          }
        }

      }
    }
  },

  created() {
    isWebP().then(hasWebP => {
      this.isWebpEnable = hasWebP
    })
  },

  computed: {
    cleanData () {
      return JSON.parse(this.rawData.replace(/'/g,'"'))
    },

    cleanLink () {
      return JSON.parse(this.link.replace(/'/g,'"'))
    },

    theme() {
      return document.head.querySelector('[property~=theme][content]').content
    }
  },

  props: {
    rawData: String,
    rawTitle: String,
    link: String
  },


  asyncComputed: {
    itemsSlider () {
      return Promise.all(this.cleanData.map((item, key) => {

        let imagePromise = new Promise((resolve, reject) => {
          getImage(item.image.ID, (response) => {
            resolve(response)
          })
        })

        return imagePromise.then((value) => {
          item.image.data =  value
          return item
        })

      })).then(values => {
        this.isDataReady = true
        return values
      })
    }
  }
}
</script>
